import { Link } from 'react-router-dom'
import { api } from '../lib/api'
import { useApi } from '../lib/useApi'
import { planPrice, money } from '../lib/format'
import { CardSkeleton } from './ui'

export default function AccountPlans() {
  const { data, error } = useApi(() => api.statement(), [], 30_000)
  const { data: plans, error: plansError } = useApi(() => api.plans(), [])
  const applications = data?.lines.filter(line => line.kind === 'application') ?? []
  const starter = plans?.find(plan => plan.tier === 'starter')
  return <section className="stack" aria-labelledby="account-plans-title">
    <h2 className="section-title" id="account-plans-title">Plans &amp; billing</h2>
    <p className="muted">Each application has its own plan. Its frontend and backend share one bill; your profile does not need a separate subscription.</p>
    {error && <div className="alert error">{error} <Link to="/billing">Open billing</Link></div>}
    {plansError && <div className="alert error">Could not load current plans. <Link to="/billing">Review plans in Billing</Link></div>}
    {!data && !error && <CardSkeleton />}
    {data && <>
      <div className="card stack">
        <div className="row" style={{ flexWrap: 'wrap', justifyContent: 'space-between' }}>
          <div><span className="tiny muted">Wallet balance</span><h3>{money(data.balance, data.currency ?? 'ETB')}</h3></div>
          <Link className="btn" to="/billing">Manage billing &amp; top up</Link>
        </div>
        {Number(data.shortfall) > 0 && <p className="alert warn">Add {money(data.shortfall, data.currency ?? 'ETB')} to cover the next round of renewals.</p>}
      </div>
      {applications.length === 0 && <div className="card card-pad-lg stack">
        <h3>No application plan yet</h3>
        <p className="muted">Choose a plan when you create your first application. Starter and higher include custom domains{starter ? `, from ${planPrice(starter)}/month` : ''}. Free websites and trials use the included TalariCloud address until you activate a paid plan.</p>
        <div className="row"><Link className="btn primary" to="/services/new">Choose a plan &amp; deploy</Link><Link className="btn" to="/billing">Compare plans</Link></div>
      </div>}
      {applications.map(line => {
        const eligible = line.custom_domains_allowed === true
        return <div className="card stack" key={line.id}>
          <div className="row" style={{ flexWrap: 'wrap', justifyContent: 'space-between' }}>
            <div><h3>{line.name}</h3><p className="tiny muted">{line.plan_label}{line.why_free ? ` · ${line.why_free}` : ` · ${planPrice(line)}/month`}</p></div>
            <Link className={`btn ${!eligible ? 'primary' : ''}`} to={`/projects/${line.id}`}>{!eligible ? 'Upgrade plan' : 'Manage application plan'}</Link>
          </div>
          {plans && <p className="tiny muted">{eligible ? 'Custom domains included for this application.' : 'Custom domains require a paid Starter plan or higher for this application.'} Plan changes show their price before you confirm.</p>}
        </div>
      })}
    </>}
  </section>
}
